import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';
import {Common} from '../../common/actionTypes';
import {downloadFile} from '../../common/util/file';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
  'filteredList': [],
  'pageSize': 20,
  'pageNumber': 0,
};

const getPage = (list, pageNumber, pageSize) => {
  if (list.length <= pageSize) {
    return [...list];
  }
  if (list.length > (pageSize * (pageNumber + 1))) {
    return [...list].slice(
      (pageSize * pageNumber),
      (pageSize * (pageNumber + 1))
    );
  }
  return [...list].slice(pageNumber * pageSize);
};

export const partAudit = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_PART_AUDIT]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_PART_AUDIT]: (state, action) => ({
      ...state,
      'list': action.response.data,
      'filteredList': [...getPage(action.response.data, 0, state.pageSize)],
      'loading': false,
    }),
    [ActionTypes.FETCHED_PART_AUDIT_FAILED]: (state, action) => ({
      ...state,
      'list': [],
      'filteredList': [],
      'loading': false,
    }),
    [ActionTypes.DELETE_PART_AUDIT_DATA]: () => ({
      ...state,
      'list': [],
      'filteredList': [],
      'loading': false,
      'pageSize': 20,
      'pageNumber': 0,
    }),
    [Common.CHANGE_LIST_PAGE]: (state, action) => ({
      ...state,
      'pageNumber': action.payload,
      'filteredList': [...getPage(state.list, action.payload, state.pageSize)],
    }),
    [Common.CHANGE_LIST_PAGE_SIZE]: (state, action) => ({
      ...state,
      'pageSize': action.payload,
      'pageNumber': 0,
      'filteredList': [...getPage(state.list, 0, action.payload)],
    }),
    [ActionTypes.DOWNLOADING_PART_AUDIT_FILE]: (state, action) => ({
      ...state,
      'downloading': true,
    }),
    [ActionTypes.DOWNLOADED_PART_AUDIT_FILE]: (state, action) => {
      downloadFile(action.response.data);
      return ({
        ...state,
        'downloading': false,
      });
    },
    [ActionTypes.DOWNLOADED_PART_AUDIT_FILE_FAILED]: (state, action) => ({
      ...state,
      'downloading': false,
    }),
  })(state, action);
};
